module.exports = __webpack_public_path__ + "static/media/cogs-small.9604dd40.jpg";